import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HashRouter, Route, Link, Routes } from "react-router-dom";
import Dialog from "../components/Dialog";
import Text from "../components/Text";
import Bookmarks from "../components/Bookmarks";
import TopMenu from "../components/TopMenu";
import { IconType } from "../components/Icon";
import { checkRights, isMobile, setValidatedStorageItem } from "../core/Helper";
import Login from "../components/Login";
import Home from "../components/Home";
import StoryBoard from "../components/StoryBoard";
import { getVersion, loginUser } from "../services/apiService";
import Welcome from "../components/Welcome";
import Fogg from "../components/Fogg";
import Impressum from "../components/Impressum";
import MediaPlayer from "../components/MediaPlayer";
import News from "../components/News";
import Pictures from "../components/Pictures";
import { setKey } from "../stores/AppReducer";
import { IMenu, KeyCode } from "../interfaces/App";
import Status from "../components/Status";
import Chat from "../components/Chat";
import Reset from "../components/Reset";
import Authlink from "../components/Authlink";
import User from "../components/User";
import Profile from "../components/Profile";
import MediaDatabase from "../components/MediaDatabase";
import PrivateRoute from "../components/PrivateRoute";
import Register from "../components/Register";
import type { AppDispatch, IApplicationState } from "../stores/AppStore";
import Target from "../components/Target";
import Messages from "../components/Messages";
import NewToken from "../components/NewToken";
import Api from "../components/Api";
import { registerServiceWorker } from "../core/serviceWorker";
import { attachSwMessageHandler } from "../services/pushService";
import Tanker from "../components/Tanker";
import "../styles/main.scss";

function App() {
    const [state, setState] = useState({ left: false, right: false, mobile: false });
    const app = useSelector((appState: IApplicationState) => appState.app);
    let count = 0;
    const dispatch = useDispatch<AppDispatch>();
    const [menu, setMenu] = useState([]);
    const redirect = () => {
        if (document.location.href.indexOf("token=") > -1) {
            const token = document.location.href.replace(/^.+#\/token=(.+)/, "$1");
            const baseUrl = document.location.href.replace(/^(.+)#\/token=.+/, "$1");
            setValidatedStorageItem("AUTHTOKEN", token);
            const url = baseUrl + "#welcome";
            document.location.href = url;
        }
    };
    useEffect(() => {
        if (count === 0) {
            redirect();
            setState({ ...state, mobile: isMobile() });
            if (localStorage.getItem("AUTHTOKEN") !== null) {
                dispatch(loginUser(null));
            }
            dispatch(getVersion(null)); // .then((res: any) => console.log(res));
            count++;
            (async () => {
                console.log("register service worker");
                await registerServiceWorker();
                attachSwMessageHandler();
            })();
        }
        window.addEventListener("keydown", keyDonwHandler);
    }, []);
    useEffect(() => {
        document.getElementsByTagName('html')[0].style.fontSize = String(app.fontSize) + "px";
    }, [app.fontSize]);

    const keyDonwHandler = (ev: any) => {
        switch (ev.key) {
            case "ArrowLeft": dispatch(setKey(KeyCode.left)); break;
            case "ArrowRight": dispatch(setKey(KeyCode.right)); break;
            case "Escape": dispatch(setKey(KeyCode.esc)); break;
            default: break;
        }
    };
    useEffect(() => {
        const tmpMenu = [];
        if (getRights("images/haus")) { tmpMenu.push({ title: "Bilder", link: "/pictures/Aktuell/:Neu", selected: false }) };
        // if (getRights("images/holzhaus")) { tmpMenu.push({ title: "Holzhaus", link: "/pictures/Holzhaus/:Siedlungsbau1927", selected: false }) };
        if (getRights("chatRead")) { tmpMenu.push({ title: "Chat", link: "/chat", selected: false }) };
        if (getRights("bookmarks")) { tmpMenu.push({ title: "Bookmarks", link: "/bookmarks", selected: false }) };
        if (getRights("AVATAR")) { tmpMenu.push({ title: "Users", link: "/user", selected: false }) };
        if (getRights("media")) { tmpMenu.push({ title: "Media", link: "/media", selected: false }) };
        if (getRights("tanken")) { tmpMenu.push({ title: "Tanken", link: "/tanken", selected: false }) };
        tmpMenu.push({ title: "LOGIN", link: "/login", selected: false });
        tmpMenu.push({ title: "AKTUELL", link: "/news/:idx", selected: false });
        // if (getRights("time")) {tmpMenu.push({title: "Time", link: "/time", selected: false})};
        setMenu(tmpMenu);
    }, [app.user.rights]);
    useEffect(() => {
        setMenu([...menu.map((mnu: IMenu) => { mnu.selected = app.subtitle === mnu.title; return mnu; })]);
    }, [app.subtitle]);

    const getRights = (path: string): boolean => {
        return checkRights(app.user, path);
    };
    const renderMainMenu = () => {
        return (
            <div className="menu top">
                <ul>
                    <li className={app.subtitle === "Profile" ? "selected" : ""}><a href="#/login" >{app.loggedIn ? app.user.name : "LOGIN"}</a></li>
                    <li className={app.subtitle === "News" ? "selected" : ""}><a href="#/news/:idx" >AKTUELL</a></li>
                </ul>
            </div>
        );
    };
    const renderBurgerMenu = () => {
        return (
            <TopMenu
                open={state.right}
                classNames={"rightMenuBox"}
                onClick={() => setState({ ...state, right: !state.right, left: false })}
                icons={[IconType.back, IconType.burger]}
            >
                {menu.map((mnu: IMenu, idx: number) => {
                    return (
                        <div key={"mnu_" + idx} className="menuItem">
                            <Link to={mnu.link}>{mnu.title}</Link>
                        </div>
                    )
                })}
            </TopMenu>
        );
    };
    const renderInlineMenu = () => {
        return state.mobile
            ? (null)
            : (
                <ul className="menu main clear">
                    {menu.map((mnu: IMenu, idx: number) => {
                        return (
                            <li key={"mnu_" + idx} className={mnu.selected ? "selected" : ""}>
                                <Link to={mnu.link}>{mnu.title}</Link>
                            </li>
                        )
                    })}
                </ul>
            );
    };
    return (
        <HashRouter>
            <div onClick={() => setState({ ...state, left: false, right: false })}>
                <div className="header">
                    <div className={`logo ${app.isAvatar ? "avatar" : ""}`}>
                        <a href="#/">Microfix.de</a>
                    </div>
                    {!(state.mobile && app.loggedIn) && renderMainMenu()}
                    {(state.mobile && app.loggedIn) && renderBurgerMenu()} {/* in mobile mode only */}
                    <div className="clear"/>
                </div>
                {renderInlineMenu()}
                <div
                    // onMouseDown={(ev: any) => handleMouseDown(ev, true)}
                    // onMouseUp={(ev: any) => handleMouseDown(ev, false)}
                    className="content clear"
                >
                    <div className="page">
                        <h2><MediaPlayer />{app.subtitle}<span>{app.loggedIn && app.user.readonly ? "(Nur lesen)" : ""}</span></h2>
                        <div className="clear" />
                        <Routes>
                            <Route path="/target/:what" element={<Target />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/dialog" element={(<Dialog />)} />
                            <Route path="/text" element={(<Text />)} />
                            <Route path="/welcome" element={(<Welcome />)} />
                            <Route path="/register" element={(<Register />)} />
                            <Route path="/bookmarks" element={
                                <PrivateRoute altPath="/login" authorized={getRights("bookmarks")}>
                                    <Bookmarks data={app.bookmarks} />
                                </PrivateRoute>}
                            />
                            {/* <Route path="/images/haus" element={
                                <PrivateRoute altPath="/login" authorized={getRights("images/haus")}>
                                    <Cloud path="images/Haus/"/>
                                </PrivateRoute>}
                            />
                            <Route path="/images/AbtFranz" element={
                                <PrivateRoute altPath="/login" authorized={getRights("images/AbtFranz")}>
                                    <Cloud path="images/AbtFranz/"/>
                                </PrivateRoute>}
                            />  */}
                            <Route path="/pictures/Aktuell/:what" element={
                                <PrivateRoute altPath="/login" authorized={getRights("images/haus")}>
                                    <Pictures path="Aktuell" />
                                </PrivateRoute>}
                            />
                            <Route path="/pictures/Holzhaus/:what" element={
                                <PrivateRoute altPath="/login" authorized={getRights("images/haus")}>
                                    <Pictures path="Holzhaus" />
                                </PrivateRoute>}
                            />
                            <Route path="/user" element={
                                <PrivateRoute altPath="/login" authorized={getRights("AVATAR")}>
                                    <User />
                                </PrivateRoute>}
                            />
                            <Route path="/profile/:what" element={
                                <PrivateRoute altPath="/login" authorized={app.loggedIn}>
                                    <Profile />
                                </PrivateRoute>}
                            />
                            <Route path="/media" element={
                                <PrivateRoute altPath="/login" authorized={getRights("bookmarks")}>
                                    <MediaDatabase />
                                </PrivateRoute>}
                            />
                            <Route path="/newToken" element={
                                <PrivateRoute altPath="/login" authorized={app.loggedIn}>
                                    <NewToken />
                                </PrivateRoute>}
                            />
                            <Route path="/tanken" element={
                                <PrivateRoute altPath="/login" authorized={app.loggedIn}>
                                    <Tanker />
                                </PrivateRoute>}
                            />
                            <Route path="/status/:token" element={(<Status />)} />
                            <Route path="/reset/:token" element={(<Reset />)} />
                            {/* <Route path="/watch"  element={(<WatchPage time={app.time} />)} /> */}
                            {/* <Route path="/time">
                                <TimeLog />
                            </Route> */}
                            {/* <Route path="/editor"  element={(<Wysiwyg/>)} />  */}
                            <Route path="/sb" element={(<StoryBoard />)} />
                            <Route path="/impressum" element={(<Impressum />)} />
                            <Route path="/news/:idx" element={(<News />)} />
                            {/* <Route path="/cube" element={(<Pictures/>)} /> */}
                            <Route path="/chat" element={(<Chat />)} />
                            <Route path="/api" element={(<Api />)} />
                            <Route path="/authlink" element={(<Authlink />)} />
                            <Route path="/" element={(<Home />)} />
                        </Routes>
                    </div>
                </div>
                {/* <div className="footer">
                    <div className="inner claus">
                        App: {app.env.app} / {app.pageCounter} API: {app.env.api} 
                        &nbsp;{state.mobile ? "mobile" : "desktop"}
                        &nbsp;{app.loggedIn ? app.user.name : "logout"}
                        <a className="impressum" href="#/impressum">Impressum</a>
                    </div>
                </div> */}
                <Fogg />

                {/* {app.confirm && <Confirm />}  */}
            </div>
            <div className="footer">
                <Messages />
                <a href="#/impressum" >IMPRESSUM</a>
                <div className="clear" />
            </div>
        </HashRouter>
    );
}

export default (App);


